import { gql } from "apollo-boost";

export const CREATE_CHEF_WEEKLY_SCHEDULE = gql`
  mutation createSchedule($chefId: ID!, $weekschedule: WeekScheduleInput!) {
    createSchedule(chefId: $chefId, weekschedule: $weekschedule)
  }
`;

export const UPDATE_CHEF_WEEKLY_SCHEDULE = gql`
  mutation updateSchedule(
    $chefId: ID!
    $days: [DAY_OF_WEEK]!
    $slot: TimeSlotInput!
  ) {
    updateSchedule(chefId: $chefId, days: $days, slot: $slot) {
      daySchedules {
        day
        slots {
          start
          end
        }
      }
    }
  }
`;

export const CREATE_CANDIDATE = gql`
  mutation createCandidate($chef: CandidateInput!) {
    createCandidate(chef: $chef)
  }
`;

export const UPDATE_CHEF_PAYOUT = gql`
  mutation updateChefPayoutMethod($chefId: ID!, $payout: PayoutMethodInput!) {
    updateChefPayoutMethod(chefId: $chefId, payout: $payout)
  }
`;

export const CREATE_SUBSCRIPTION = gql`
  mutation createSubscription($id: ID!, $priceId: ID!, $cardId: ID!, $discountCode: String) {
    createSubscription(id: $id, priceId: $priceId, cardId: $cardId, discountCode: $discountCode)
  }
`;

export const CANCEL_SUBSCRIPTION = gql`
  mutation cancelSubscription($id: ID!, $subscriptionId: ID!) {
      cancelSubscription(id: $id, subscriptionId: $subscriptionId)
  }
`;

export const CREATE_DINER_JOB = gql`
    mutation createDinerJob($jobDate: Date!, $jobTime: String!, $description: String!) {
      createDinerJob(jobDate: $jobDate, jobTime: $jobTime, description: $description)
    }
`;

export const CHANGE_SUBSCRIPTION = gql`
  mutation changeSubscription($id: ID!, $priceId: ID!, $cardId: ID!, $subscriptionId: ID!, $discountCode: String, $changedPrice: Float) {
    changeSubscription(id: $id, priceId: $priceId, cardId: $cardId, subscriptionId: $subscriptionId, discountCode: $discountCode, changedPrice: $changedPrice)
  }
`;
